/*
 *  lang=>对应的中英文翻译 *
 *  type=>提示类型 *
 *  errorCode=>错误代码 * => 例如 81000005
 * */

export const toTips = {
  // Start Stop的时候的提示
  81000005: 'lang.timeOut',
  81100207: 'lang.sourceNotHave',
  81100101: 'lang.ReceiverNotExist',
  81100102: 'lang.receiverOffline',
  81100103: 'lang.sourceNotExist',
  81100105: 'lang.Sourceliving',
  81100106: 'lang.unknow',
  81100107: 'lang.PeerNotFound',
  81100108: 'lang.ReceiverDeviceOnLine',
  81100109: 'lang.PeerIncorrectStatus',
  81100110: 'lang.SourceNotBelongToUser',
  81100111: 'lang.ReceiverNotBelongToUser',
  81000014: 'lang.UserRoleNoFeature',
  81100201: 'lang.ReceiverNotExist',
  81100202: 'lang.receiverOffline',
  81100203: 'lang.receiverOnline',
  81100204: 'lang.unknow',
  81100205: 'lang.PeerNotFound',
  81100206: 'lang.GivenPeerNotSelected',
  81100112: 'lang.isBooking',
  81100015: 'lang.currentRLiveSourceNotBelongToUser',
  81000004: 'lang.receiverNotConnect',
  81100114: 'lang.i18n_startLiveFailed',
  // Start Stop的时候的提示 结束
  81000902: 'lang.bookmarkNameTips',
  81000801: 'lang.bookmarkNameTips',
  81000701: 'lang.useExist',
  '0x80100005': 'lang.GivenPeerNotSelected',
  // advance control
  81000101: 'lang.nameExist',
  // timelock
  81100504: 'lang.synchronizing',
  81100505: 'lang.deviceSynchronizing',
  // common
  '0x0': 'lang.success',
  // booking
  // booking.addEvent
  80601701: 'lang.invalidSourcePeerId',
  80601702: 'lang.invalidDestPeerId',
  80601703: 'lang.sourceTypeIsNull',
  80601704: 'lang.invalidStartTime',
  80601705: 'lang.invalidEndTime',
  80601706: 'lang.endTimeMoreStartTime',
  80601707: 'lang.startTimeMoreCurTime',
  80601708: 'lang.sourceSetDelay',
  80601709: 'lang.delayInputRange',
  80601710: 'lang.sourceSetBitrate',
  80601711: 'lang.bitrateInput',
  80601712: 'lang.extMustSetUrl',
  80600702: 'lang.bookingRTimeconflict',
  80600703: 'lang.bookingTTimeconflict',
  80602311: 'lang.startTimeLessThanCurTime',
  80602313: 'lang.endTimeMoreStartTime',
  80602314: 'lang.delayRang',

  // booking.delete
  80600705: 'lang.deleteEventFail',
  80600704: 'lang.eventIdEmpty',

  // token.editDeviceName
  '0x5': 'lang.faildCallTpcModifyName',

  // scte
  80601804: 'lang.nameIsExist',
  // source control
  81101502: 'lang.channelOccupied',

  // alert
  80600700: 'lang.errorCodeFormartError',

  82600107: 'lang.overMax',
  82600106: 'lang.nameIsExist',
  82600108: 'lang.overDevice',
  // 删除视频错误提示
  80602506: 'lang.DeleteVideo',
  // 10/20/2021
  80050007: 'lang.lang.InvalidSession',
  80602301: 'lang.lang.EventCanntNull',
  80602302: 'lang.EventNotExist',
  80602303: 'lang.TitleCanntNull',
  80602304: 'lang.SourceCanntNull',
  80602305: 'lang.SourceNotExist',
  80602306: 'lang.ChannelCanntNull',
  80602307: 'lang.UgcCanntNull',
  80602308: 'lang.GroupCanntNull',
  80602309: 'lang.InvalidStart',
  80602310: 'lang.InvalidEnd',
  80602312: 'lang.EndMustBigger',
  80602315: 'lang.BitrateTips',
  80602316: 'lang.CanntUpdateStart',
  80602317: 'lang.EventFinished',
  80602318: 'lang.EventCanntBeUpdate',
  80602319: 'lang.EventTypeCanntUpdate',
  80600720: 'lang.WillFinishedTips',
  80602321: 'lang.RTimeConflict',
  80602322: 'lang.SourceTimeConflict',
  80602323: 'lang.UgcTimeConflict',
  80602324: 'lang.MsgFailed',
  80602325: 'lang.MsgFailed',
  80602326: 'lang.TCanntNull',
  80602327: 'lang.ScteEventIdTips',
  80602328: 'lang.ScteEventNotExist',
  80602336: 'lang.UpdateConflict',
  80602329: 'lang.ScteCanntUpdate',
  80602330: 'lang.DurationFail',
  80602331: 'lang.RNotLiving',
  // 80602332: 'lang.Receiver id is not empty',
  80602333: 'lang.SourceOffline',
  80602334: 'lang.SourceLiving',
  80602335: 'lang.RepeatedlyTips',
  80602337: 'lang.RIsNotTaking',
  80602338: 'lang.AccountNoEvent',
  80602001: 'lang.NoChannel',
  80602002: 'lang.RTimeConflict',
  80602003: 'lang.TTimeConflict',
  80602004: 'lang.IdEmpty',
  80602005: 'lang.DeleteFail',
  80602006: 'lang.EndFail',
  80602007: 'lang.ScteConflict',
  80602008: 'lang.NoRTips',
  80602009: 'lang.DeleteFailed',
  80602010: 'lang.RequiredTimeout',
  80602011: 'lang.EventEmpty',
  80602012: 'lang.TakeBreakSourceFailed',
  80602013: 'lang.StopBreakSourceFailed',
  80602014: 'lang.NoEventExecuted',
  80602015: 'lang.VideoUsed',
  80602016: 'lang.NewsRunning',
  80602101: 'lang.NotScte',
  80602102: 'lang.NotNickName',
  80602103: 'lang.ScteUsedTips',
  80602104: 'lang.ScteCanntDelete',
  80600706: 'lang.ParamCanntNull',
  80600707: 'lang.ScteIdCanntNull',
  80600708: 'lang.ConvertError',
  80600709: 'lang.ScteIdCanntNull',
  80600710: 'lang.TypeWrong',
  80600711: 'lang.ExistScte',
  80600712: 'lang.RIsLiving',
  80600713: 'lang.CanntStop',
  80600716: 'lang.InconsistentType',
  80600714: 'lang.SetScteFailed',
  80600715: 'lang.SetScteTimeOut',
  80602201: 'lang.FileNotExist',
  80602202: 'lang.FileExist',
  80602203: 'lang.UploadFailed',
  80602204: 'lang.UploadFailed',
  80602205: 'lang.VideoTimeEmpty',
  80602206: 'lang.FileIdEmpty',
  80602207: 'lang.FileTypeError',
  80602208: 'lang.SessionEmpty',
  80602209: 'lang.NoFileInDriver',
  806022010: 'lang.ParamsEmpty',
  806022011: 'lang.FailedUseService',
  806022012: 'lang.FileNameOver',
  806022013: 'lang.FileNameEmpty',
  806022014: 'lang.MediaIdUsed',
  806022015: 'lang.MediaIdUsed',
  806022016: 'lang.ParamsEmpty',
  80602401: 'lang.NoGroup',
  80602501: 'lang.RecoredExist',
  80602502: 'lang.RecordNotExist',
  80602503: 'lang.EventNotExist',
  // 80602504: 'Call drive create dir failed',
  // 80602505: 'Sync drive dir failed',
  // 80602601: 'Call drive query failed',
  // 80602602: 'Call drive del failed',
  // 80602603: 'Call drive rename failed',
  // 80602604: 'Call drive move failed',
  // 80602605: 'Call drive post failed',
  80602606: 'lang.AddFileFailed',
  80602607: 'lang.AddFolderFailed',
  80602608: 'lang.DelteFolderFailed',
  80602609: 'lang.FolderNameEmpty',
  80602610: 'lang.ParentIdEmpty',
  80602616: 'lang.FileIdEmpty',
  80602611: 'lang.GetFileIdFailed',
  80602612: 'lang.GetBucketIdFailed',
  80602613: 'lang.BucketCodeEmpty',
  80602614: 'lang.NpUserInDriver',
  80602615: 'lang.BucketNotExist',
  80602701: 'lang.ParamCanntNull',
  80602702: 'lang.LocationError',
  80602703: 'lang.ImageError',
  80602704: 'lang.SetLogoError',
  80602705: 'lang.ResultError',
  80602706: 'lang.NoRTips',
  80602707: 'lang.RNoLive',
  80602708: 'lang.GetRInfoError',
  80602709: 'lang.NoSelectLogo',
  80602801: 'lang.UseExtError',
  80602802: 'lang.LogOutError',
  80602803: 'lang.ListSourceRErr',
  80602804: 'lang.CreateRFailed',
  80602805: 'lang.GetRIdFailed',
  80602806: 'lang.CreateInstanceFailed',
  80602807: 'lang.ShutdownFailed',
  80602901: 'lang.IdErr',
  80602902: 'lang.NoDevice',
  80602903: 'lang.RNoLive',
  80602904: 'lang.RIdEmpty',
  80602905: 'lang.FrequentTips',
  // 80603001: 'Call Device Service exception',
  // 80603002: 'Call User Service exception',
  // 80603003: 'Call MessageRecordService exception',
  // 80603004: 'Call RWS Service exception',
  // 80603005: 'Call Drive Service exception',
  // 80603006: 'Call Tpc Service exception',
  // 80603007: 'Call Instance Service exception',
  // 80603008: 'Call User Group Service exception',
  80603009: 'lang.RestartFailed',
  80603010: 'lang.RestartFailed',
  80603101: 'lang.TemIdEmpty',
  80603102: 'lang.TemExist',
  80603103: 'lang.TimingInErr',
  80603104: 'lang.TimingOutErr',
  80603105: 'lang.TimingErr',
  80603106: 'lang.TotalTimeErr',
  80603107: 'lang.SegmentTypeErr',
  80603108: 'lang.SegmentIdErr',
  80603109: 'lang.FileFormatErr',
  80603110: 'lang.EpisodeSizeErr',
  80603111: 'lang.TemNameErr',
  80603112: 'lang.HouseIdErr',
  80603113: 'lang.TemNameExist',
  80603114: 'lang.MediaIdEmpty',
  80603115: 'lang.TimingInAndOutErr',
  80603116: 'lang.DescriptionErr',
  80603117: 'lang.TotalTimeZero',
  80603201: 'lang.NoUser',
  80603202: 'lang.UserIdEmpty',
  80603203: 'lang.SessionEmpty',
  80603204: 'lang.ParentExist',
  80603205: 'lang.EmailEmpty',
  80603206: 'lang.SessionFailed',
  80603207: 'lang.ParentIdFailed',
  80603208: 'lang.GetSessionFailed',
  80603301: 'lang.HeaderWrong',
  80603302: 'lang.TimingInEmpty',
  80603303: 'lang.TimingOutEmpty',
  80603304: 'lang.DownloadFailed',
  80603305: 'lang.FileErrFormat',
  80603306: 'lang.ParseXMLFailed',
  80603307: 'lang.ParsePlayFailed',
  80603308: 'lang.FileErrFormat',
  80603401: 'Call Overlay exception.',
  // 80603402: 'Call overlay create sceneId failed.',
  // 80603403: 'Call overlay delete sceneId failed.',
  // 80603404: 'Call overlay apply changes showId failed.',
  // 80603405: 'Call overlay get sceneId url failed.',
  80603406: 'lang.NoData',
  80603407: 'lang.SendFailed',
  80603408: 'lang.GetCrawFailed',
  80603501: 'lang.SetCrawFirst',
  80603502: 'lang.CrawlOpend',
  80603503: 'lang.CrawlClosed',
  80603602: 'lang.IncorrectData',
  80603601: 'lang.ParseDataErr',
  80603701: 'lang.HasName',
  80603702: 'lang.NoProName',
  80603703: 'lang.HasClosed',
  80603704: 'lang.CanntDeleted',
  80603705: 'lang.CanntClosed',
  80603706: 'lang.NoOwnerUser',
  80603707: 'lang.EnterEmail',
  80603708: 'lang.HasShared',
  80603709: 'lang.HasNoPermission',
  80603711: 'lang.HasNotShared',
  80603712: 'lang.CancelErr',
  80603710: 'lang.ReachedLimit',
  81003801: 'lang.GetPIdFailed',
  81003802: 'lang.GetPIdFailed',
  81002801: 'lang.CallInstancefailed',
  81002802: 'lang.GetRegionFailed',
  81002803: 'lang.CreateFailed',
  81002804: 'lang.ShutdownFailed',
  81002805: 'lang.CreateFailed',
  81002806: 'lang.GetInstanceFailed',
  81002807: 'lang.GetElasticFailed',
  81002808: 'lang.BindIpFailed',
  81002809: 'lang.ReleaseIpFailed',
  81002901: 'lang.TemNameEmpty',
  81002902: 'lang.TemNameLimit',
  81002903: 'lang.TemNameExist',
  81002904: 'lang.CreateTemFailed',
  81002905: 'lang.StartLessEnd',
  81002906: 'lang.ExistStartLessEnd',
  81003001: 'lang.NoSharePermission',
  81003101: 'lang.FileNoCreated'
}
export default toTips
